import { getRng } from './utils/random';

const defaultWords = [
  "PUZZLE", "GARDEN", "FAMILY", "SCHOOL", "FRIEND", "SUMMER", 
  "WINTER", "ANIMAL", "NATURE", "TRAVEL", "DREAM", "ACTION"
];

export const generateScramble = (count = 6, customWords = null, seed = null) => {
  const rng = getRng(seed);
  const wordsToUse = customWords || defaultWords;
  
  // نختارو كلمات عشوائية من اللائحة
  const selectedWords = [];
  const indices = [...Array(wordsToUse.length).keys()];
  
  // خلط المؤشرات
  for (let i = indices.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [indices[i], indices[j]] = [indices[j], indices[i]];
  }

  // أخذ العدد المطلوب
  for (let i = 0; i < Math.min(count, wordsToUse.length); i++) {
    selectedWords.push(wordsToUse[indices[i]].toUpperCase());
  }

  const puzzles = selectedWords.map(word => {
    // خربقة حروف الكلمة
    let shuffled = word.split('');
    // خلط Fisher-Yates
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(rng() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    
    // تأكد أن الكلمة مخربقة فعلاً (ماشي نفس الأصلية)
    if (shuffled.join('') === word) {
       // قلب الحرفين الأولين كحل سريع
       [shuffled[0], shuffled[1]] = [shuffled[1], shuffled[0]];
    }

    return {
      original: word,
      scrambled: shuffled.join('')
    };
  });

  return puzzles;
};